import { Helmet } from 'react-helmet-async';
import { ANDROID_PLAY_STORE_URL, IOS_APP_STORE_URL } from '@/lib/store';
import { LLMS_TXT_URL, OG_IMAGE_URL, SITE_ORIGIN, siteUrl } from '@/lib/site';

type SeoProps = {
  title: string;
  description: string;
  path: string;
};

export function Seo({ title, description, path }: SeoProps) {
  const url = siteUrl(path);
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${SITE_ORIGIN}/#organization`,
        name: 'Hmonglus',
        url: `${SITE_ORIGIN}/`,
        logo: `${SITE_ORIGIN}/app-icon.png`,
        sameAs: [IOS_APP_STORE_URL, ANDROID_PLAY_STORE_URL],
      },
      {
        '@type': 'WebSite',
        '@id': `${SITE_ORIGIN}/#website`,
        name: 'Hmonglus',
        url: `${SITE_ORIGIN}/`,
        description:
          'Learn White Hmong and Hmong Leng with flashcards, stories, pronunciation, and games.',
        publisher: { '@id': `${SITE_ORIGIN}/#organization` },
      },
      {
        '@type': 'SoftwareApplication',
        '@id': `${SITE_ORIGIN}/#app`,
        name: 'Hmonglus',
        applicationCategory: 'EducationalApplication',
        operatingSystem: 'iOS, Android, Web',
        offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
        url: `${SITE_ORIGIN}/`,
        description:
          'Learn White Hmong and Hmong Leng with flashcards, stories, pronunciation, and games.',
        publisher: { '@id': `${SITE_ORIGIN}/#organization` },
      },
      {
        '@type': 'WebPage',
        '@id': `${url}#webpage`,
        url,
        name: title,
        description,
        isPartOf: { '@id': `${SITE_ORIGIN}/#website` },
      },
    ],
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <link rel="describedby" href={LLMS_TXT_URL} />
      <meta property="og:site_name" content="Hmonglus" />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE_URL} />
      <meta property="og:image:alt" content="Hmonglus — Learn Hmong with flashcards and games" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE_URL} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
